/**
 * Apakah alamat ini halaman hasil pasien (/patient/:token)? Dipakai index.js untuk memuat entri
 * ringan alih-alih seluruh aplikasi viewer. `/patient/` tanpa token, atau dengan bagian jalur
 * tambahan, bukan halaman pasien: biarkan aplikasi lengkap menampilkan halaman tidak ditemukan.
 */
export function adalahHalamanPasien(pathname: string, basename = '/'): boolean {
  const dasar = String(basename || '/').replace(/\/+$/, '');
  const awalan = `${dasar}/patient/`;
  if (!pathname.startsWith(awalan)) {
    return false;
  }
  return /^[^/]+\/?$/.test(pathname.slice(awalan.length));
}

/**
 * Alamat penampil gambar untuk pasien. Halaman pasien berjalan di entri ringan yang hanya mengenal
 * rute /patient/:token (tanpa aplikasi viewer), jadi pindah ke penampil harus berupa pemuatan
 * halaman penuh, bukan perpindahan rute di dalam aplikasi: dengan `navigate`, alamat berganti
 * tetapi tidak ada yang menampilkannya sampai halaman dimuat ulang.
 */
export function urlPenampilGambar(studyInstanceUid: string, basename = '/'): string {
  const dasar = String(basename || '/').replace(/\/+$/, '');
  return `${dasar}/viewer?StudyInstanceUIDs=${encodeURIComponent(studyInstanceUid)}&mode=patient`;
}
